export function toggleModalForm() {
    const modalForm = document.querySelector('.modal-form');

    modalForm.classList.toggle('show');
    document.body.classList.toggle('overflow');
}
